// @flow
import React, { type Node, useMemo, useCallback } from 'react';

import PlainDatePicker from 'app/common/ui-next/plain-date-picker';
import SimpleDate from 'app/dataProviders/SimpleDate';

import styles from './WeekSwitcher.scss';


type Props = {
  date: SimpleDate,
  onChangeDate: (SimpleDate) => void,
  dateDisabledStatus?: (dayFormatted: string, format: string, unit?: string) => boolean,
}

const WeekSwitcher = ({ date, onChangeDate, dateDisabledStatus }: Props): Node => {
  const period = useMemo(() => {
    const mDay = date.createMoment();
    const momentDay = !mDay.day() ? mDay.day(-1) : mDay;
    const start = momentDay.day(1).format('DD.MM');
    const end = momentDay.day(6).format('DD.MM');
    return `${start} — ${end}`;
  }, [date]);

  const handleDateChange = useCallback((date_: string, format: string) => {
    onChangeDate(new SimpleDate(date_, format));
  }, [onChangeDate]);

  return (
    <div className={styles.root}>
      <div className={styles.period}>
        {period}
      </div>
      <PlainDatePicker
        date={date.getValue()}
        dateFormat={date.getFormat()}
        onDateChange={handleDateChange}
        dateDisabledStatus={dateDisabledStatus}
        weekSelection
      />
    </div>
  );
};

export default WeekSwitcher;
